import type { AppointmentPlanningStartRecommendation } from "../../../../../../api/kehrblatt/planning"
import { formatDateOnly } from "../../../_logic/dates"
import type { PlanningStartPreset } from "../../../_logic/planning-start-preset"
import { dateOnlyInTimezone } from "../../../../../_shared/_logic/timezones"

export const resolveStartRecommendation = (
  response: AppointmentPlanningStartRecommendation,
  { defaultPreset, now = new Date() }: { defaultPreset: PlanningStartPreset; now?: Date },
): { startDate: string; preset: PlanningStartPreset; timezone: string } | null => {
  const standard = formatDateOnly(response.default_start_date)

  if (!standard) return null

  const today = dateOnlyInTimezone(now, response.timezone)

  if (!today) return null

  // Add a calendar day, not 24 hours to a zoned instant (DST).
  const nextDay = new Date(`${today}T00:00:00Z`)
  nextDay.setUTCDate(nextDay.getUTCDate() + 1)
  const tomorrow = nextDay.toISOString().slice(0, 10)
  const earlier = formatDateOnly(response.recommended_start_date)
  const useEarlier =
    response.source === "earlier_gap" && earlier && tomorrow <= earlier && earlier < standard

  return {
    startDate: useEarlier ? earlier : standard,
    preset: useEarlier ? "custom" : defaultPreset,
    timezone: response.timezone,
  }
}
